import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import Pagination from "../components/Pagination";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export default function FishesPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [fishes, setFishes] = useState([]);
    const [meta, setMeta] = useState({ page: 1, pages: 1, total: 0 });
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const page = Math.max(1, Number(searchParams.get("page") || 1));
    const query = searchParams.get("q") || "";
    const [searchInput, setSearchInput] = useState(query);
    const needsScrollRef = useRef(false);

    useEffect(() => {
        setSearchInput(query);
    }, [query]);

    useEffect(() => {
        setLoading(true);
        setMessage("");
        axios
            .get(`${API_BASE_URL}/api/fish`, { params: { page, q: query || undefined, limit: 12 } })
            .then((response) => {
                const data = response.data || {};
                if (Array.isArray(data)) {
                    setFishes(data);
                    setMeta({ page: 1, pages: 1, total: data.length });
                    return;
                }
                setFishes(data.items || []);
                setMeta({
                    page: data.page || page,
                    pages: data.pages || 1,
                    total: data.total || 0,
                });
            })
            .catch(() => {
                setFishes([]);
                setMessage("Не удалось загрузить рыбу.");
            })
            .finally(() => setLoading(false));
    }, [page, query]);

    const updateParams = (nextPage, nextQuery = query) => {
        const params = {};
        if (nextQuery.trim()) params.q = nextQuery.trim();
        if (nextPage > 1) params.page = String(nextPage);
        setSearchParams(params);
        needsScrollRef.current = true;
    };

    useEffect(() => {
        if (needsScrollRef.current) {
            needsScrollRef.current = false;
            requestAnimationFrame(() => {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            });
        }
    }, [fishes]);

    const onSearchSubmit = (event) => {
        event.preventDefault();
        updateParams(1, searchInput);
    };

    return (
        <div className="blog-page-root">
            <div className="blog-page-inner">
                <div className="blog-page-header">
                    <div className="blog-head">
                        <h2 className="blog-page-title">Каталог рыб</h2>
                        <form className="blog-search" onSubmit={onSearchSubmit}>
                            <input
                                type="search"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                placeholder="Поиск"
                            />
                            <button type="submit" className="blog-search__button" aria-label="Найти">
                                <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                    <path
                                        d="M10.5 4a6.5 6.5 0 0 1 5.17 10.44l4.45 4.44-1.24 1.24-4.44-4.45A6.5 6.5 0 1 1 10.5 4Zm0 1.75a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        </form>
                    </div>
                </div>

                {!!message && <p className="cms-page-loading">{message}</p>}
                {loading && <p className="cms-page-loading">Загрузка...</p>}
                {!loading && fishes.length === 0 && <p className="cms-page-loading">Рыбы пока не добавлены.</p>}

                <div className="fishes-page-grid">
                    {fishes.map((fish) => (
                        <article className="fish-glass-card" key={fish.id}>
                            <div className="fish-glass-card__body">
                                <div className="fish-glass-card__top">
                                    <span className={`fish-glass-card__badge${fish.isPredator ? " fish-glass-card__badge--predator" : " fish-glass-card__badge--peaceful"}`}>
                                        {fish.isPredator ? "Хищная" : "Мирная"}
                                    </span>
                                </div>
                                <h3 className="fish-glass-card__name">{fish.name}</h3>
                                <p
                                    className="fish-glass-card__desc"
                                    dangerouslySetInnerHTML={{ __html: fish.shortDescription || "Описание отсутствует" }}
                                />
                            </div>
                            <div className="fish-glass-card__footer">
                                <Link to={`/fishes/${fish.slug}`} className="btn-outline fish-glass-card__link">
                                    Подробнее
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>

                <Pagination currentPage={meta.page} totalPages={meta.pages} onPageChange={(nextPage) => updateParams(nextPage)} />
                {!loading && meta.total > 0 && (
                    <p className="cms-page-loading">Найдено: {meta.total}</p>
                )}
            </div>
        </div>
    );
}
